import Registration from "../../../../jsx/pages/Agent/Registration";

const LoginWrapper = function (props) {
  return <Registration />;
};

export default constore(LoginWrapper);
